<template>
  <RevDrawer
    :close-button-label="i18n(translations.mobileFiltersClose)"
    :name="DRAWER_NAME"
    size="large"
    :title="i18n(translations.filtersTitle)"
  >
    <template #body>
      <Filters :merchant-id :reset-filters variant="full" />
    </template>
    <template #footer>
      <RevButton
        full-width="always"
        variant="primary"
        @click="handleFilterCloseModal"
      >
        {{ i18n(translations.applyFilters) }}
      </RevButton>

      <RevLink
        class="body-2-link mt-12 w-full !text-center"
        @click="handleResetFilters"
      >
        {{ i18n(translations.resetFilters) }}
      </RevLink>
    </template>
  </RevDrawer>

  <RevButton
    :icon="IconEqualizer"
    size="small"
    variant="primary"
    @click="handleFilterOpenModal"
  >
    {{ i18n(translations.filtersTitle) }}
  </RevButton>
</template>

<script lang="ts" setup>
import { inject } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevDrawer } from '@ds/components/Drawer'
import { RevLink } from '@ds/components/Link'
import { closeModal, openModal } from '@ds/components/ModalBase'
import { IconEqualizer } from '@ds/icons/IconEqualizer'

import { scrollToTargetKey } from '../../constants'

import translations from './Filters.translations'
import Filters from './Filters.vue'
import { useFilters } from './composables/useFilters'

const DRAWER_NAME = 'MobileFiltersDrawer'

const i18n = useI18n()
const scrollToTarget = inject<() => void>(scrollToTargetKey)
const { resetFiltersValues } = useFilters(scrollToTarget)

defineProps<{
  merchantId?: string
  resetFilters?: number
}>()

function handleFilterOpenModal() {
  openModal(DRAWER_NAME)
}

function handleFilterCloseModal() {
  closeModal(DRAWER_NAME)
}

async function handleResetFilters() {
  await resetFiltersValues()
  handleFilterCloseModal()
}
</script>
